"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tutorialsSaga = exports.fetchTutorialVideos = exports.fetchTutorialVideoDetails = void 0;
var effects_1 = require("redux-saga/effects");
var typesafe_actions_1 = require("typesafe-actions");
var api_client_1 = require("@portal/api-client");
var get_cms_client_1 = __importDefault(require("@portal/common/dist/utils/get-cms-client"));
var even_cms_1 = require("@portal/even-cms");
var actions_1 = require("./actions");
function fetchTutorialVideoIds(filter) {
    var config, client_1, portalWalkthroughScreens, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4, (0, effects_1.select)(function (state) { return state; })];
            case 1:
                config = (_a.sent()).config;
                client_1 = (0, get_cms_client_1.default)(even_cms_1.ItemsPortalWalkthroughScreensApi, config);
                return [4, (0, effects_1.call)([
                        client_1,
                        'readItemsPortalWalkthroughScreens',
                    ])];
            case 2:
                portalWalkthroughScreens = (_a.sent()).data.data;
                portalWalkthroughScreens = (portalWalkthroughScreens === null || portalWalkthroughScreens === void 0 ? void 0 : portalWalkthroughScreens.filter(filter)) || [];
                return [2, portalWalkthroughScreens.map(function (_a) {
                        var videoId = _a.body;
                        return videoId ? Number(videoId) : undefined;
                    })];
            case 3:
                e_1 = _a.sent();
                return [2, 0];
            case 4: return [2];
        }
    });
}
function fetchTutorialVideoDetails(action) {
    var videoId, data, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 6]);
                return [4, (0, effects_1.call)(fetchTutorialVideoIds, function (item) { return item.title === action.payload.type; })];
            case 1:
                videoId = (_a.sent())[0];
                return [4, (0, effects_1.call)([api_client_1.client, 'get'], "/tutorials/video/".concat(videoId))];
            case 2:
                data = (_a.sent()).data;
                return [4, (0, effects_1.putResolve)(actions_1.getTutorialVideoDetails.success(__assign(__assign({}, data), { type: action.payload.type })))];
            case 3:
                _a.sent();
                return [3, 6];
            case 4:
                err_1 = _a.sent();
                return [4, (0, effects_1.put)(actions_1.getTutorialVideoDetails.failure(err_1))];
            case 5:
                _a.sent();
                return [3, 6];
            case 6: return [2];
        }
    });
}
exports.fetchTutorialVideoDetails = fetchTutorialVideoDetails;
function fetchTutorialVideos(action) {
    var type, config, cmsClient_1, walkthrough_1, videoIds_1, videos, err_2;
    var _this = this;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                type = action.payload.type;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 7, , 9]);
                return [4, (0, effects_1.select)(function (state) { return state; })];
            case 2:
                config = (_a.sent()).config;
                cmsClient_1 = (0, get_cms_client_1.default)(even_cms_1.ItemsPortalWalkthroughsApi, config);
                return [4, (0, effects_1.call)(function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2, cmsClient_1
                                    .readItemsPortalWalkthroughs(undefined, undefined, undefined, undefined, undefined, undefined)
                                    .then(function (res) { var _a; return ((_a = res.data.data) === null || _a === void 0 ? void 0 : _a.filter(function (x) { return x.path === type; })) || []; })];
                        });
                    }); })];
            case 3:
                walkthrough_1 = (_a.sent())[0];
                return [4, (0, effects_1.call)(fetchTutorialVideoIds, function (item) { var _a; return ((_a = walkthrough_1.screens) === null || _a === void 0 ? void 0 : _a.findIndex(function (x) { return x === item.id; })) !== -1; })];
            case 4:
                videoIds_1 = _a.sent();
                return [4, (0, effects_1.call)(function () { return __awaiter(_this, void 0, void 0, function () {
                        var _this = this;
                        return __generator(this, function (_a) {
                            return [2, Promise.all(videoIds_1.map(function (id) { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        return [2, api_client_1.client
                                                .get("/tutorials/video/".concat(id))
                                                .then(function (res) { return res.data; })];
                                    });
                                }); }))];
                        });
                    }); })];
            case 5:
                videos = _a.sent();
                return [4, (0, effects_1.putResolve)(actions_1.getTutorialVideos.success({
                        type: type,
                        videos: videos,
                    }))];
            case 6:
                _a.sent();
                return [3, 9];
            case 7:
                err_2 = _a.sent();
                return [4, (0, effects_1.put)(actions_1.getTutorialVideos.failure(err_2))];
            case 8:
                _a.sent();
                return [3, 9];
            case 9: return [2];
        }
    });
}
exports.fetchTutorialVideos = fetchTutorialVideos;
function tutorialsSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, (0, effects_1.takeLatest)((0, typesafe_actions_1.getType)(actions_1.getTutorialVideoDetails.request), fetchTutorialVideoDetails)];
            case 1:
                _a.sent();
                return [4, (0, effects_1.takeLatest)((0, typesafe_actions_1.getType)(actions_1.getTutorialVideos.request), fetchTutorialVideos)];
            case 2:
                _a.sent();
                return [2];
        }
    });
}
exports.tutorialsSaga = tutorialsSaga;
